import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import KlevuSmartSlider from './KlevuSmartSlider';

const rootElement = document.getElementById('REACT_klevu_smart_recommendation');

if (rootElement) {
  const tabsJson = rootElement.dataset.tabs;
  const tabs = tabsJson ? JSON.parse(tabsJson) : [];

  const root = createRoot(rootElement);
  root.render(
    <Sentry.ErrorBoundary>
      <KlevuSmartSlider tabs={tabs} />
    </Sentry.ErrorBoundary>
  );
}
